
import Vue from 'vue'
import Router from 'vue-router'


import Index from '@/components/index'
import placeIndex from '@/components/placeOrder/placeIndex' //下单
import Introduce from '@/components/placeOrder/introduce' //介绍页面
import Trajectory from '@/components/placeOrder/Trajectory' //轨迹查询


import Personalindex from '@/components/PersonalCenter/Personalindex' //个人中心
import userCountshow from '@/components/PersonalCenter/userCountshow' //个人中心首页展示
import BulkOrderbysea from '@/components/PersonalCenter/BulkOrder/BulkOrderbysea' //海运散货
import Mybill from '@/components/PersonalCenter/billType/Mybill' //我的账单
import tabelTest from '@/components/PersonalCenter/billType/tabelTest' //我的账单
import PayDetail from '@/components/PersonalCenter/billType/PayDetail' //我的账单
import PayOrder from '@/components/PersonalCenter/billType/PayOrder' //支付
import PayRecord from '@/components/PersonalCenter/billType/PayRecord' //我的账单
import waitConfirmed from '@/components/PersonalCenter/billType/waitConfirmed' //待确认费用
import customerAmonutBalance from '@/components/PersonalCenter/billType/customerAmonutBalance' //账户流水




import UserManage from '@/components/PersonalCenter/accountManage/UserManage' //用户管理
import SubaccountManage from '@/components/PersonalCenter/accountManage/SubaccountManage' //子账号管理
import ManagementRole from '@/components/PersonalCenter/accountManage/ManagementRole'//角色管理
import PermissionAssignment from '@/components/PersonalCenter/accountManage/PermissionAssignment'//查看权限，分配权限
// 个人中心

import ReceivePage from '@/components/PersonalCenter/personalInfo/ReceivePage' //收件人
import PickPage from '@/components/PersonalCenter/personalInfo/PickPage' //提货人
import SendPage from '@/components/PersonalCenter/personalInfo/SendPage' //发货人
import MyCollect from '@/components/PersonalCenter/personalInfo/MyCollect' //我的收藏
import TrackSetting from '@/components/PersonalCenter/personalInfo/TrackSetting' //轨迹设置
import Consignment from '@/components/placeOrder/Consignment' //托运信息
import Qdbill from '@/components/placeOrder/Qdbill' //确认托运
import orderSuccess from '@/components/placeOrder/orderSuccess' //委托完成

import buikAllbox from '@/components/PersonalCenter/buikAllbox/buikAllbox' //海运整柜
import AirOrder from '@/components/PersonalCenter/AirOrder/AirOrder' //空运
import AirOrderDetail from '@/components/PersonalCenter/AirOrder/AirOrderDetail' //空运

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// FBA
import FbaCargo from '@/components/FBAorder/FbaCargo' //下单第一页
import Fbaservice from '@/components/FBAorder/Fbaservice' //FBA增值服务
import Fbaconsignment from '@/components/FBAorder/Fbaconsignment' //FBA托运信息
import Fbaqdbill from '@/components/FBAorder/Fbaqdbill' //FBA确认委托
import FbaorderSuccess from '@/components/FBAorder/FbaorderSuccess' //FBA委托完成
import FBAheader from '@/components/PersonalCenter/FBAheader/FBAheader' //FBA委托完成
import FbaOrderDetails from '@/components/PersonalCenter/FBAheader/FbaOrderDetails' //FBA委托完成
import Classify from '@/components/PersonalCenter/personalInfo/Classify' //商品分类
import FbaGoodsBase from '@/components/PersonalCenter/FBAheader/FbaGoodsBase' //FBA商品基本信息
import FbnAppointment from '@/components/PersonalCenter/FBAheader/FbnAppointment' //FBN约仓管理
import FbaChangebill from '@/components/PersonalCenter/FBAheader/FbaChangebill' //修改订单
import newBillCargoChang from '@/components/PersonalCenter/FBAheader/newBillCargoChang' //修改订单
import ScanLodop from '@/components/PersonalCenter/Scanprint/ScanLodop' //扫描打印
import PrivateAddress from '@/components/PersonalCenter/PrivateAddrs/PrivateAddress' //私人地址
import PrivateOrderDetails from '@/components/PersonalCenter/PrivateAddrs/PrivateOrderDetails'  //私人详情
import PrivateOrderChang from '@/components/PersonalCenter/PrivateAddrs/PrivateOrderChang'  //私人修改



import BillCargo from '@/components/NewOrder/BillCargo' //New  玖域-下单页面
import newBillCargo from '@/components/NewOrder/newBillCargo' //New  玖域-下单页面

// 空运
import AirCargoIndex from '@/components/airOrder/AirCargoIndex' //下单第一页
import AirMoreService from '@/components/airOrder/AirMoreService' //增值服务
import AirConsignment from '@/components/airOrder/AirConsignment' //托运信息
import AirConfirmPage from '@/components/airOrder/AirConfirmPage' //确认托运
import AirOrderSuccess from '@/components/airOrder/AirOrderSuccess' //委托完成

// 订单管理
// import enterWarehouseConfirm from '@/components/orderManagement/enterWarehouseConfirm' //入仓订单确认
// import enterWarehouseOrderDetails from '@/components/orderManagement/enterWarehouseOrderDetails' //入仓订单确认

//私人地址下单
import privateBill from '@/components/privateOrder/privateBill' //私人地址订单
import jiuyuIndex from '@/components/FBAindex/index'    //新加登入页

// 404
import NotFoundPage from '@/NotFoundPage.vue'
import {getWxLoginBeforePageParams, wxCodeSwapUserCode, wxQrCodeLogin} from "@/assets/js/utils.login";

NProgress.configure({ showSpinner: false }) // 配置NProgress

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
const router = new Router({
    mode: "history",
    routes: [
        // {
        //     path: '/',
        //     name: 'index',
        //     component: () => import('../index')
        // },
        {
            path: '/',
            // name: 'index',
            component: Index,
            children: [

                {
                    path: '/', //下单index
                    component: () => import('../components/placeOrder/placeIndex')
                },
                {
                    path: 'questionnaire', // 问卷
                    component: () => import('../components/questionnaire/index')
                },
                {
                    path: 'placeOrder/introduce', //介绍页面
                    name: 'Introduce',
                    component: () => import('../components/placeOrder/introduce'),
                },
                {
                    path: 'placeOrder/brandIntroduce', //品牌页面
                    name: 'brandIntroduce',
                    component: () => import('../components/placeOrder/brandIntroduce'),
                },
                {
                    path: 'placeOrder/Trajectory', //轨迹
                    name: 'Trajectory',
                    component: () => import('../components/placeOrder/Trajectory'),
                },
                {
                    path: 'placeOrder/Guide', //用户指南
                    name: 'Guide',
                    component: () => import('../components/placeOrder/Guide'),
                },
                {
                    path: 'placeOrder/supplierJoin', //平台入驻
                    name: 'supplierJoin',
                    component: () => import('../components/placeOrder/supplierJoin'),
                },
                {
                    path: 'placeOrder/supplyChainFinanceApply', //供应链金融
                    name: 'supplyChainFinanceApply',
                    component: () => import('../components/placeOrder/supplyChainFinance/supplyChainFinanceApply'),
                },
                {
                  path:"/hotEvents",// 热门活动
                  component: () => import('../components/hotEvents/index')
                },
                {
                    path: 'placeOrder/Consignment', //增值服务
                    name: 'Consignment',
                    component: () => import('../components/placeOrder/Consignment'),
                },
                {
                    path: 'placeOrder/MemberZone', //会员专区
                    name: 'MemberZone',
                    component: () => import('../components/placeOrder/MemberZone'),
                },
                {
                    path: 'placeOrder/MemberZoneDetail', //会员专区明细
                    name: 'MemberZoneDetail',
                    component: () => import('../components/placeOrder/MemberZoneDetail'),
                },
                
                {
                    path: 'placeOrder/Qdbill', //确认委托
                    name: 'Qdbill',
                    component: () => import('../components/placeOrder/Qdbill'),
                },
                {
                    path: 'Personalindex/payOrder', //支付
                    name: 'payOrder',
                    component: () => import('../components/PersonalCenter/billType/PayOrder'),

                },
                {
                    path: 'Personalindex/orderSuccess', //完成委托
                    name: 'orderSuccess',
                    component: () => import('../components/placeOrder/orderSuccess'),
                },

                {
                    path: 'NewOrder/BillCargo',//new玖域  下单第一页
                    name: 'BillCargo',
                    component: () => import('../components/NewOrder/BillCargo'),

                },
                {
                    path: 'NewOrder/newBillCargo',//new玖域  急速下单下单第一页
                    name: 'newBillCargo',
                    component: () => import('../components/NewOrder/newBillCargo'),
                },
                {
                    path: 'privateOrder/privateBill',//私人地址下单
                    name: 'privateBill',
                    component: () => import('../components/privateOrder/privateBill'),
                },
                {
                    path: 'FBAorder/FbaCargo',//fba  下单第一页
                    name: 'FbaCargo',
                    component: () => import('../components/FBAorder/FbaCargo'),

                },
                {
                    path: 'takeOrder',// 下单
                    name: 'takeOrder',
                    component: () => import('../components/takeOrder'),
                },
                {
                    path: 'FBAorder/Fbaservice',//fba增值服务
                    name: 'Fbaservice',
                    component: () => import('../components/FBAorder/Fbaservice'),
                },
                {
                    path: 'FBAorder/Fbaconsignment',//fba托运信息
                    name: 'Fbaconsignment',
                    component: () => import('../components/FBAorder/Fbaconsignment'),
                },
                {
                    path: 'FBAorder/Fbaqdbill',//fba确认委托
                    name: 'Fbaqdbill',
                    component: () => import('../components/FBAorder/Fbaqdbill'),
                },
                {
                    path: 'FBAorder/FbaorderSuccess',//fba 委托完成
                    name: 'FbaorderSuccess',
                    component: () => import('../components/FBAorder/FbaorderSuccess'),
                },

                // 空运
                {
                    path: 'airOrder/AirCargoIndex',//  下单第一页
                    name: 'AirCargoIndex',
                    component: () => import('../components/airOrder/AirCargoIndex'),

                },
                {
                    path: 'airOrder/AirMoreService',//增值服务
                    name: 'AirMoreService',
                    component: () => import('../components/airOrder/AirMoreService'),
                },
                {
                    path: 'airOrder/AirConsignment',//托运信息
                    name: 'AirConsignment',
                    component: () => import('../components/airOrder/AirConsignment'),
                },
                {
                    path: 'airOrder/AirConfirmPage',//确认委托
                    name: 'AirConfirmPage',
                    component: () => import('../components/airOrder/AirConfirmPage'),
                },
                {
                    path: 'airOrder/AirOrderSuccess',// 委托完成
                    name: 'AirOrderSuccess',
                    component: () => import('../components/airOrder/AirOrderSuccess'),
                },

                // 修改1

                {
                    path: '/news', //新闻页
                    name: 'news',
                    component: () => import('../components/news/newsList'),
                },
                {
                    path: '/newsDetails', //新闻页
                    name: 'newsDetails',
                    component: () => import('../components/news/newsDetails'),
                },
                {
                    path: 'placeOrder/placeindexInfo/inquiryHall', // 整柜询盘
                    name: 'inquiryHall',
                    component: () => import('../components/placeOrder/placeindexInfo/inquiryHall'),
                },
                {
                    path: 'placeOrder/publishedInquiry', // 发布询盘
                    name: 'publishedInquiry',
                    component: () => import('../components/publishedInquiry'),
                },
                {
                    path: 'placeOrder/publishedInquiry/publishedSuccess', // 发布询盘
                    name: 'publishedSuccess',
                    component: () => import('../components/publishedInquiry/publishedSuccess'),
                },
                {
                    path: 'placeOrder/inquiryTakeOrder', // 询盘下单
                    name: 'inquiryTakeOrder',
                    component: () => import('../components/inquiryTakeOrder'),
                },
                {
                    path: 'placeOrder/inquiryTakeOrder/bulkCargo', // 询盘下单（散货）
                    name: 'inquiryTakeOrderBulkCargo',
                    component: () => import('../components/inquiryTakeOrder/bulkCargo'),
                },
                {
                    path: 'placeOrder/inquiryTakeOrder/bulkCargo/success', // 询盘下单成功（散货）
                    name: 'inquiryTakeOrderBulkCargoSuccess',
                    component: () => import('../components/inquiryTakeOrder/bulkCargoSuccess'),
                },
                {
                    path: 'placeOrder/inquiryTakeOrder/success', // 询盘下单
                    name: 'inquiryTakeOrder',
                    component: () => import('../components/inquiryTakeOrder/success'),
                },
                {
                    path: 'placeOrder/placeindexInfo/queryPrice', //fba查价下单
                    name: 'queryPrice',
                    meta: { keepAlive: true },
                    component: () => import('../components/placeOrder/placeindexInfo/queryPrice'),
                },
                {
                    path: 'placeOrder/placeindexInfo/Smallbag', //小包查价下单
                    name: 'Smallbag',
                    component: () => import('../components/placeOrder/placeindexInfo/Smallbag'),
                },

                {
                    path: 'index/PersonalCenter/Personalindex', //个人中心首页默认空页面
                    name: 'Personalindex',
                    component: () => import('../components/PersonalCenter/Personalindex'),
                    children: [
                        {
                            path: 'PersonalCenter/BulkOrder/BulkOrderbysea', //海运散货
                            name: 'BulkOrderbysea',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/BulkOrder/BulkOrderbysea'),
                        },
                        {
                            path: 'PersonalCenter/userCountshow', //个人中心首页展示
                            name: 'userCountshow',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/userCountshow'),

                        },
                        {
                            path: 'PersonalCenter/billType/Mybill', //我的账单
                            name: 'Mybill',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/billType/Mybill'),
                        },
                        {
                            path: 'PersonalCenter/billType/PayDetail', //支付详情
                            name: 'PayDetail',
                            component: () => import('../components/PersonalCenter/billType/PayDetail'),
                        },
                        {
                            path: 'PersonalCenter/billType/PayRecord', //我的账单
                            name: 'PayRecord',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/billType/PayRecord'),
                        },
                        {
                            path: 'PersonalCenter/billType/customerAmonutBalance', //账户流水
                            name: 'customerAmonutBalance',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/billType/customerAmonutBalance'),
                        },
                        {
                            path: 'PersonalCenter/billType/coupon', //优惠券页面
                            name: 'Coupon',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/billType/coupon'),
                        },
                        {
                            path: 'PersonalCenter/accountManage/UserManage', ////用户管理
                            name: 'UserManage',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/accountManage/UserManage'),
                        },
                        {
                            path: 'PersonalCenter/accountManage/SubaccountManage', ////子账号管理
                            name: 'SubaccountManage',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/accountManage/SubaccountManage'),
                        },
                        {
                            path: 'PersonalCenter/accountManage/ManagementRole', //角色管理
                            name: 'ManagementRole',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/accountManage/ManagementRole'),
                        },
                        {
                            path: 'PersonalCenter/accountManage/PermissionAssignment', //角色管理,查看权限，分配权限
                            name: 'PermissionAssignment',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/accountManage/PermissionAssignment'),
                        },
                        {
                            path: 'PersonalCenter/personalInfo/Classify', ////商品分类
                            name: 'Classify',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/personalInfo/Classify'),
                        },
                        {
                            path: 'PersonalCenter/personalInfo/FbaGoodsBase', //商品基本信息
                            name: 'FbaGoodsBase',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/FBAheader/FbaGoodsBase'),
                        },
                        {
                            path: 'PersonalCenter/personalInfo/FbnAppointment', //fbn约仓管理
                            name: 'FbnAppointment',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/FBAheader/FbnAppointment'),
                        },
                        {
                            path: 'PersonalCenter/personalInfo/ReceivePage', ////收货人
                            name: 'ReceivePage',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/personalInfo/ReceivePage'),
                        },

                        {
                            path: 'PersonalCenter/personalInfo/PickPage', ////提货人
                            name: 'PickPage',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/personalInfo/PickPage'),
                        },

                        {
                            path: 'PersonalCenter/personalInfo/SendPage', ////发货人
                            name: 'SendPage',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/personalInfo/SendPage'),
                        },
                        {
                            path: 'PersonalCenter/personalInfo/MyCollect', ////我的收藏
                            name: 'MyCollect',
                            meta: { title: true },
                            component: () => import('@/components/PersonalCenter/personalInfo/MyCollect'),
                        },
                        {
                            path: 'PersonalCenter/personalInfo/TrackSetting', ////轨迹
                            name: 'TrackSetting',
                            component: () => import('@/components/PersonalCenter/personalInfo/TrackSetting'),
                            meta: { title: true },
                        }
                        ,
                        {
                            path: 'PersonalCenter/personalInfo/messageCenter', // 消息中心
                            name: 'messageCenter',
                            meta: { title: true },
                            component: () => import('@/components/PersonalCenter/personalInfo/messageCenter'),
                        },
                        {
                            path: 'PersonalCenter/personalInfo/messageDetails/:id', //FBA订单详情
                            name: 'messageDetails',
                            meta: { title: true },
                            component: () => import('@/components/PersonalCenter/personalInfo/messageDetails'),
                        },
                        {
                            path: 'PersonalCenter/buikAllbox/buikAllbox', //海运整柜
                            name: 'buikAllbox',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/buikAllbox/buikAllbox'),

                        },
                        {
                            path: 'PersonalCenter/AirOrder/AirOrder', //空运
                            name: 'AirOrder',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/AirOrder/AirOrder'),

                        },
                        {
                            path: 'PersonalCenter/AirOrder/AirOrderDetail', //空运详情
                            name: 'AirOrderDetail',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/AirOrder/AirOrderDetail'),

                        },

                        {
                            path: 'PersonalCenter/FBAheader/FBAheader', //Fba头程
                            name: 'FBAheader',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/FBAheader/FBAheader'),
                        },
                        {
                            path: 'PersonalCenter/Scanprint/ScanLodop', //扫描打印
                            name: 'ScanLodop',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/Scanprint/ScanLodop'),
                        },
                        {
                            path: 'PersonalCenter/PrivateAddrs/PrivateAddress', //私人地址
                            name: 'PrivateAddress',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/PrivateAddrs/PrivateAddress'),
                        },
                        {
                            path: 'PersonalCenter/FBAheader/FbaChangebill', //Fba修改订单
                            name: 'FbaChangebill',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/FBAheader/FbaChangebill'),
                        },
                        {
                            path: 'PersonalCenter/FBAheader/newBillCargoChang', //Fba修改订单
                            name: 'newBillCargoChang',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/FBAheader/newBillCargoChang'),
                        },
                        {
                            path: 'PersonalCenter/FBAheader/FbaOrderDetails/:state/:nos/:isFastOrder/:thirdNos', //FBA订单详情
                            // path: 'PersonalCenter/FBAheader/FbaOrderDetails', //FBA订单详情
                            name: 'FbaOrderDetails',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/FBAheader/FbaOrderDetails'),
                        },
                        {
                            path: 'PersonalCenter/PrivateAddrs/PrivateOrderDetails/:state/:id', //私人地址详情
                            name: 'PrivateOrderDetails',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/PrivateAddrs/PrivateOrderDetails'),
                        },
                        {
                            path: 'PersonalCenter/PrivateAddrs/PrivateOrderChang', //私人地址修改
                            name: 'PrivateOrderChang',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/PrivateAddrs/PrivateOrderChang'),
                        },
                        {
                            path: 'PersonalCenter/MyOrder/MyOrderDetails', //我的订单
                            name: 'MyOrderDetails',
                            meta: { title: true, keepAlive: true },
                            component: () => import('../components/PersonalCenter/MyOrder/MyOrderDetails'),
                        },
                        // {
                        //     path: 'PersonalCenter/SmallPackets/SmallPackets', // 电商小包
                        //     name: 'SmallPackets',
                        //     meta: { title: true, keepAlive: true },
                        //     component: () => import('../components/PersonalCenter/SmallPackets/SmallPackets'),
                        // },
                        {
                            path: 'PersonalCenter/managementOfInvoices/InvoiceApply', //去开票
                            name: 'InvoiceApply',
                            meta: { title: true,},
                            component: () => import('../components/PersonalCenter/billType/InvoiceApply'),
                        },
                        {
                            path: 'PersonalCenter/billType/MyInvoice', //我的发票
                            name: 'MyInvoice',
                            meta: { title: true,},
                            component: () => import('../components/PersonalCenter/billType/MyInvoice'),
                        },
                        {
                            path: 'PersonalCenter/billType/InvoiceDetails', //发票详情
                            name: 'InvoiceDetails',
                            meta: { title: true,},
                            component: () => import('../components/PersonalCenter/billType/InvoiceDetails'),
                        },
                        {
                            path: 'PersonalCenter/billType/InvoiceEdit', //发票管理
                            name: 'InvoiceEdit',
                            meta: { title: true,},
                            component: () => import('../components/PersonalCenter/billType/InvoiceEdit'),
                        },
                        {
                            path: 'PersonalCenter/trackManagement/trackSettings', //轨迹推送
                            name: 'InvoiceaApply',
                            meta: { title: true, },
                            component: () => import('../components/PersonalCenter/trackManagement/trackSettings'),
                        },
                        {
                            path: 'PersonalCenter/inquiryManage/publishedInquiry', // 我发布的询盘
                            name: 'publishedInquiry',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/inquiryManage/publishedInquiry')
                        },
                        {
                            path: 'PersonalCenter/inquiryManage/inquiryDetails/:id', // 询盘详情
                            name: 'inquiryDetails',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/inquiryManage/inquiryDetails')
                        },
                        {
                            path: 'PersonalCenter/inquiryManage/myOrder', // 我的询盘订单
                            name: 'publishedInquiry',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/inquiryManage/myOrder')
                        },
                        {
                            path: 'PersonalCenter/inquiryManage/orderDetails/:id', // 询盘订单详情
                            name: 'orderDetails',
                            meta: { title: true },
                            component: () => import('../components/PersonalCenter/inquiryManage/orderDetails')
                        },

                        // {
                        //   path: 'orderManagement/enterWarehouseConfirm', //入仓订单确认
                        //   component: enterWarehouseConfirm,
                        //   name: 'enterWarehouseConfirm',
                        //   meta: { title: true }
                        // },
                        // {
                        //   path: 'orderManagement/enterWarehouseOrderDetails', //入仓订单详情
                        //   component: enterWarehouseOrderDetails,
                        //   name: 'enterWarehouseOrderDetails',
                        //   meta: { title: true }
                        // },
                        // {
                        //   path: '/404',
                        //   name: 'NotFound-page',
                        //   component: NotFoundPage
                        // },
                        // {
                        //   path: '*',
                        //   redirect: "/404",
                        //   name: 'NotFound',
                        // }
                    ]
                },
                {
                    path: 'placeOrder/platformSharedWarehouse', //供应链金融
                    name: 'platformSharedWarehouse',
                    // component: () => import('../components/placeOrder/platformSharedWarehouse/index'),
                    component: () => import('../components/placeOrder/platformSharedWarehouse/newIndex'),
                },
                {
                    path: 'placeOrder/saas', //saas宣传页
                    name: 'saas',
                    component: () => import('../components/placeOrder/saas/index'),
                }
            ],
        },
        {
            path: '/index', //个人中心登录页
            name: 'Introduce',
            component: () => import('../components/FBAindex/index'),
        },
        // {
        //     path: '/news', //新闻页
        //     name: 'news',
        //     component: () => import('../components/news/newsList'),
        // },
        // {
        //     path: '/newsDetails', //新闻页
        //     name: 'newsDetails',
        //     component: () => import('../components/news/newsDetails'),
        // },
        {
            path: '*',
            redirect: "/",
            name: 'NotFound',
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

//挂载路由导航守卫
router.beforeEach((to, from, next) => {
  NProgress.start()
  const {indexLoginMsg, code, state} = to.query;
  if (indexLoginMsg || (code && state)) {
    console.group("获取到扫码登录参数");
    console.log("to = ",to);
    console.log("from = ",from);
    console.log(indexLoginMsg,code,state);
    console.groupEnd();
    const newTo = getWxLoginBeforePageParams();
    // 扫码登录错误
    if (indexLoginMsg) {
      this.$message.error(indexLoginMsg)
      return next(newTo);
    } else {
      console.log("交换登录信息");
      return wxCodeSwapUserCode(code,state)
        .then(res=>{
          return wxQrCodeLogin({
            code: res.data,
          })
        })
        .then(res=>{
          if(newTo.path === "/login") newTo.path = "/index/PersonalCenter/Personalindex/PersonalCenter/userCountshow";
          next(newTo);
        })
        .catch(res=>{
          console.error(res);
          next(newTo);
        })
    }
  } else {
    next()
  }

})
router.afterEach(() => {
    NProgress.done()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js